<div class="page-content-wrapper">
  <div class="row g-4">
    <div class="col-sm-12 col-md-3">
      <icon-card title="Applications" :count="applications" icon_class="fa fa-cogs"/>
    </div>
    <div class="col-sm-12 col-md-3">
      <icon-card title="Clients" :count="client" icon_class="fas fa-users"/>
    </div>
    <div class="col-sm-12 col-md-3">
      <icon-card title="Client Admins" :count="client_admin" icon_class="fas fa-user-shield"/>
    </div>
    <div class="col-sm-12 col-md-3">
      <icon-card title="Admins" :count="admins" icon_class="fas fa-user-shield"/>
    </div>
  </div>
</div>